export const getLetters = (name) => {
    let nm;
    const arrN = name.split(' ');
    if (arrN.length > 1) {
        const cad = `${arrN[0]}`;
        const cad2 = `${arrN[1]}`;
        nm = cad.charAt(0) + cad2.charAt(0);
    } else {
        nm = arrN[0].charAt(0) + arrN[0].charAt(1);
    }
    return nm;
};

export const porcentA = (total, us) => {
    const t = parseInt(total);
    const u = parseInt(us);
    const porcent = (u / t) * 100;
    return porcent.toFixed(1);
};
export const porcetColor = (por) => {
    if (por < 50) {
        return 'primary';
    }
    if (por > 50 && por < 80) {
        return 'warning';
    }
    if (por > 80) {
        return 'danger';
    }
};
export const conMoneda = (numero = 0) => {
    return numero.toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
    });
};
export const isEmpty = (obj) => {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
    }

    return true;
};
export const addMac = (mac) => {
    let mc = mac;
    if (mac.length === 2 || mac.length === 5 || mac.length === 8 || mac.length === 11 || mac.length === 14) {
        mc += ':';
    }

    return mc;
};
export const htmlTxt = (input) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = input;
    return textarea.value;
};

export const getPermissions = (array, titulo, subtitulo) => {
    const objetoEncontrado = {};
    for (let i = 0; i < array.length; i++) {
        if (array[i].title === titulo) {
            for (let j = 0; j < array[i].list.length; j++) {
                if (array[i].list[j].sub === subtitulo) {
                    const chks = array[i].list[j].chks;
                    for (let k = 0; k < chks.length; k++) {
                        objetoEncontrado[chks[k].value] = chks[k].checked;
                    }
                }
            }
        }
    }
    return Object.keys(objetoEncontrado).length > 0 ? objetoEncontrado : null;
};

export const getPerMenu = (permissions, title) => {
    const permissionsWidgets = permissions.find((item) => item.title === title);

    if (permissionsWidgets) {
        return permissionsWidgets.permissions.reduce(
            (result, { value, checked }) => ({ ...result, [value]: checked }),
            {}
        );
    }

    return null;
};

export const checkAccess = (submenuName, accessList) => {
    for (const menu of accessList) {
        if (menu.submenus) {
            const submenu = menu.submenus.find((sub) => sub.name === submenuName);
            if (submenu) {
                return {
                    access: submenu.access !== false,
                    functions: (submenu.functions || []).reduce((acc, func) => {
                        acc[func.value] = func.access !== false;
                        return acc;
                    }, {}),
                };
            }
        }
    }

    return { access: false, functions: {} };
};
